import { JobNoteType } from "@crimsontide/core/client/interfaces";
import DotNetObject = DotNet.DotNetObject;

export const JobNoteTypeService = (() => {
  let dotNetObj: DotNetObject;
  let cachedJobNoteTypes: JobNoteType[];

  const setDotNetReference = (obj: DotNetObject): void => {
    dotNetObj = obj;
  };

  const getJobNoteTypes = async (useCache: boolean = true): Promise<JobNoteType[]> => {
    if (useCache && cachedJobNoteTypes != null)
      return cachedJobNoteTypes;

    if (dotNetObj) {
      cachedJobNoteTypes = await dotNetObj.invokeMethodAsync<JobNoteType[]>('GetAsync');
      return cachedJobNoteTypes;
    } else {
      throw 'Job Note Type DotNet Object Reference has not yet been implemented';
    }
  };

  return {
    setDotNetReference,
    getJobNoteTypes,
  };
})();
